import Ajax from '../../../../util/ajax';
export function zigbeeStop(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/8/command/stop';
        const value = {
            'execute if off': payload.executeIfOff
        };
        ajax.post(url, value);
    };
}
